import { useTheme as StyledComponentsUseTheme } from 'styled-components';
import { Theme } from './theme';

export const useTheme = (): Theme => {
  const theme = StyledComponentsUseTheme() as Theme;

  return theme;
};
